module.exports = __webpack_public_path__ + "7d8f47956eabe487050db4f9c926baca.png";